import { FormContextProvider } from "@stormwater-software/lib-form";
import { RenderContextProvider } from "@stormwater-software/ui-inspection-templates";
import React from "react";
import { DynamicBaseTemplate as Template } from "./DynamicTemplate/BaseTemplate";
import { TemplateGroupLayout } from "./DynamicTemplate/TemplateGroupLayout";
import { TemplateInput } from "./DynamicTemplate/TemplateInput";
import { TemplateQuestion } from "./DynamicTemplate/TemplateQuestion";

/**
 * User-defined inspection template.
 */
export function DynamicTemplateQuestions() {
  return (
    <FormContextProvider>
      <RenderContextProvider
        Question={TemplateQuestion}
        Input={TemplateInput}
        GroupLayout={TemplateGroupLayout}
      >
        <Template />
      </RenderContextProvider>
    </FormContextProvider>
  );
}
